import axios from 'axios'
import { TotalInvoice } from '@/domain/TotalInvoice'
import { Invoice } from '@/domain/Invoice'

/**
 * 検索条件
 */
export class SerchConditon {
    /** 合計請求番号 */
    totalInvoiceNo = ""
    /** 期間開始日 */
    startOn = ""
    /** 期間終了日 */
    endOn = ""
    /** 顧客都道府県コード */
    customerPrefectureCode = ""
    /** 顧客コード */
    customerCode = ""
    /** 顧客枝番 */
    customerBranchNumber = ""
    /** 顧客名 */
    customerName = ""
    /* 有効 */
    isActive = true

    /* 画面用 */
    /** 期間タイプ */
    dateType = 0

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<SerchConditon>) {
        Object.assign(this, init)
    }
}

/**
 * 合算請求サービス
 */
export default class TotalInvoicesService {
    /** インスタンス */
    private static _instance: TotalInvoicesService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new TotalInvoicesService();
        }
        return this._instance;
    }

    /**
     * 新規作成
     */
    public async createNew(): Promise<TotalInvoice> {
        return await axios.get("/api/total/invoice/new")
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                throw error
            })
    }
    
    /**
     * 編集
     */
    public async edit(no: string): Promise<TotalInvoice> {
        return await axios.get(`/api/total/invoice/edit/${no}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 新規保存
     */
    public async create(dto: TotalInvoice): Promise<TotalInvoice> {
        return await axios.post("/api/total/invoice/new", dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 保存
     */
    public async update(dto: TotalInvoice): Promise<TotalInvoice> {
        return await axios.put(`/api/total/invoice/edit/${dto.totalInvoiceNo}`, dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 削除
     */
    public async delete(no: string): Promise<TotalInvoice> {
        return await axios.delete(`/api/total/invoice/delete/${no}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 印刷
     */
    public async print(no: string): Promise<TotalInvoice> {
        return await axios.put(`/api/total/invoice/print/${no}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 請求一覧を検索
     */
    public async findAll(serchConditon: SerchConditon): Promise<TotalInvoice[]> {
        return await axios.get("/api/total/invoices", {params: serchConditon})
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as TotalInvoice[]).map(x => this.convert(x))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 代理店請求対象一覧を検索
     */
    public async findTarget(serchConditon: SerchConditon): Promise<Invoice[]> {
        return await axios.get("/api/total/invoices/target", {params: serchConditon})
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as Invoice[]).map(x => new Invoice({ ...x }))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 受信データの変換
     * @param data
     */
    // eslint-disable-next-line
    private convert(data: any): TotalInvoice {
        const totalInvoice = data as TotalInvoice
        return new TotalInvoice({ ...totalInvoice })
    }
}
